import RadioButton from 'components/RadioButton';
import React from 'react';
import { CustomRoleFormType } from '../custom-roles.types';
import { Controller, useFormContext } from 'react-hook-form';

const getOptions = (target: 'accessexpress' | 'nocexpress' | 'techexpress') => [
  {
    value: `hidden:${target}`,
    label: 'Hidden',
  },
  {
    value: `read:${target}`,
    label: 'Read only',
  },
  {
    value: `readWrite:${target}`,
    label: 'Read + write',
  },
];

const PermissionSelection = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CustomRoleFormType>();

  const getSelectedValue = (
    target: 'accessexpress' | 'nocexpress' | 'techexpress',
    permissions: string[] | undefined,
  ) => {
    let selectedValue = '';
    if (!permissions?.some((p) => p.includes(target))) selectedValue = '';
    else if (permissions?.includes(`readWrite:${target}`)) {
      selectedValue = `readWrite:${target}`;
    } else if (permissions?.includes(`read:${target}`)) {
      selectedValue = `read:${target}`;
    } else {
      selectedValue = `hidden:${target}`;
    }
    return selectedValue;
  };

  return (
    <>
      <div className="grid grid-cols-3 gap-6">
        <Controller
          control={control}
          name="permissions"
          render={({ field }) => {
            return (
              <RadioButton
                label="Order services"
                className="flex flex-col gap-2"
                selectedValue={getSelectedValue('accessexpress', field.value)}
                onChange={(value) => {
                  const filteredPermissions =
                    field.value?.filter((v) => !v.includes('accessexpress')) ??
                    [];
                  if (value === 'hidden' && field.value) {
                    field.onChange([...filteredPermissions]);
                  } else {
                    const newPermissions = [...filteredPermissions, value];

                    field.onChange(newPermissions);
                  }
                }}
                options={getOptions('accessexpress')}
              />
            );
          }}
        />
        <Controller
          control={control}
          name="permissions"
          render={({ field }) => {
            return (
              <RadioButton
                label="Open a repair"
                className="flex flex-col gap-2"
                selectedValue={getSelectedValue('nocexpress', field.value)}
                onChange={(value) => {
                  const filteredPermissions =
                    field.value?.filter((v) => !v.includes('nocexpress')) ?? [];
                  if (value === 'hidden' && field.value) {
                    field.onChange([...filteredPermissions]);
                  } else {
                    const newPermissions = [...filteredPermissions, value];
                    field.onChange(newPermissions);
                  }
                }}
                options={getOptions('nocexpress')}
              />
            );
          }}
        />
        <Controller
          control={control}
          name="permissions"
          render={({ field }) => {
            return (
              <RadioButton
                label="Dispatch a tech"
                className="flex flex-col gap-2"
                selectedValue={getSelectedValue('techexpress', field.value)}
                onChange={(value) => {
                  const filteredPermissions =
                    field.value?.filter((v) => !v.includes('techexpress')) ??
                    [];
                  if (value === 'hidden' && field.value) {
                    field.onChange([...filteredPermissions]);
                  } else {
                    const newPermissions = [...filteredPermissions, value];

                    field.onChange(newPermissions);
                  }
                }}
                options={getOptions('techexpress')}
              />
            );
          }}
        />
      </div>
      {errors.permissions && (
        <p className="text-xs text-input-content-error">
          {errors.permissions.message}
        </p>
      )}
    </>
  );
};

export default PermissionSelection;
